import React from "react";
import { PawPrint } from "lucide-react";

// Each species chip can filter either via `q` (substring across name/alias/city/animals_affected/crime_summary)
// OR via `crime_type` (exact crime enum). The registry chip (k:'fighting') uses crime_type so all 14
// Dog-Fighting records (including Bad Newz Kennels where summaries don't contain the literal "fighting dogs")
// are surfaced.
const SPECIES = [
  { k: "all", l: "All" },
  { k: "dog", l: "Dogs", q: "dog" },
  { k: "cat", l: "Cats", q: "cat" },
  { k: "fighting", l: "Dog Fighting Rings", crime_type: "Dog Fighting" },
  { k: "horse", l: "Horses / Livestock", q: "horse" },
  { k: "rooster", l: "Poultry / Roosters", q: "rooster" },
  { k: "cattle", l: "Cattle", q: "cattle" },
  { k: "reptile", l: "Reptiles", q: "reptile" },
  { k: "turtle", l: "Turtles", q: "turtle" },
];

function isActive(s, filters) {
  const q = (filters.q || "").toLowerCase();
  const ct = filters.crime_type || "";
  if (s.k === "all") return !q && !ct;
  if (s.crime_type) return ct === s.crime_type;
  if (s.q) return q === s.q.toLowerCase();
  return false;
}

export default function SpeciesFilterRow({ filters, setFilters }) {
  const apply = (s) => {
    // Replace ONLY the species-scope filters; keep other user-set filters intact
    setFilters((f) => ({
      ...f,
      q: s.q || "",
      crime_type: s.crime_type || "",
      page: 1,
    }));
    // No manual onSearch — parent Home.jsx useEffect([filters]) re-fetches automatically
  };

  return (
    <div
      className="border border-zinc-300 bg-zinc-50 mt-4 px-4 py-3 flex flex-wrap items-center gap-2"
      data-testid="species-filter-row"
    >
      <div className="flex items-center gap-2 pr-3 border-r border-zinc-300 mr-1">
        <PawPrint size={13} className="text-red-600" />
        <span className="label-eyebrow">Filter by animal</span>
      </div>
      {SPECIES.map((s) => {
        const active = isActive(s, filters);
        return (
          <button
            key={s.k}
            type="button"
            onClick={() => apply(s)}
            className={`px-2.5 py-1 text-[11px] uppercase tracking-widest font-bold border transition-colors ${
              active
                ? "bg-zinc-900 text-white border-zinc-900"
                : "bg-white text-zinc-900 border-zinc-300 hover:border-zinc-900"
            }`}
            data-testid={`species-filter-${s.k}`}
          >
            {s.l}
          </button>
        );
      })}
    </div>
  );
}
